// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3V4CV","button":"Footer_button__1lauy","brand":"Footer_brand__2WwKs"};